import SyntheseEntitiesController from './syntheseentities.controller';

export default {
    template: require('./syntheseentities.tpl.html'),
    controller: SyntheseEntitiesController
};
